// extracted by mini-css-extract-plugin
module.exports = {"buttonChoice":"Results_buttonChoice__50gOq","noresult":"Results_noresult__Me0dk"};